import React, { FC } from 'react'
import { Chip, Paper } from '@mui/material'
import { DataGridPremium, GridColDef } from '@mui/x-data-grid-premium'
import { ContractorTransferItem, ContractorTransferItemEntityTypeEnum } from 'src/api'
import { InnerLink, TableToolbar } from 'src/components/ui'
import { getTransferItemStatusMeta, getTransferItemTypeLabel } from 'src/components/columns/contractorTransferHelpers'

const columns: GridColDef<ContractorTransferItem>[] = [
  { field: 'entityType', headerName: 'Type', minWidth: 130, sortable: false, valueGetter: ({ row }) => getTransferItemTypeLabel(row.entityType) },
  {
    field: 'label',
    headerName: 'Name',
    minWidth: 240,
    flex: 1,
    sortable: false,
    valueGetter: ({ row }) => row.label || `#${row.entityId}`,
    renderCell: ({ value, row }) => (row.entityType === ContractorTransferItemEntityTypeEnum.Project ? <InnerLink to={`/projects/${row.entityId}`}>{value}</InnerLink> : value)
  },
  {
    field: 'status',
    headerName: 'Status',
    minWidth: 120,
    sortable: false,
    valueGetter: ({ row }) => getTransferItemStatusMeta(row.status).label,
    renderCell: ({ row }) => {
      const { label, color } = getTransferItemStatusMeta(row.status)
      return <Chip size="small" label={label} color={color} />
    }
  },
  { field: 'note', headerName: 'Note', minWidth: 240, flex: 1, sortable: false, valueGetter: ({ row }) => row.note || '' }
]

interface ContractorTransferItemsProps {
  items: ContractorTransferItem[]
  exportedFileName: string
}

/** What the transfer moves: the selected projects, memberships and devices. */
export const ContractorTransferItems: FC<ContractorTransferItemsProps> = ({ items, exportedFileName }) => (
  <Paper sx={{ width: '100%', minWidth: 0 }}>
    <DataGridPremium<ContractorTransferItem>
      rows={items}
      columns={columns}
      autoHeight
      disableRowSelectionOnClick
      pagination
      initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
      pageSizeOptions={[25, 50, 100]}
      slots={{ toolbar: () => <TableToolbar exportedFileName={exportedFileName} /> }}
      sx={{ border: 'none' }}
    />
  </Paper>
)
